export default __webpack_public_path__ + "91bf41779cba9fc4bf6d1cb863a75d68.svg";